/**
 * DP274-P3a-3 — a mark's numbers are fractions of the PAGE BOX: the rectangle
 * the sheet occupies on the canvas before zoom and pan. Store fractions and the
 * same note lands on the same detail of the drawing on a phone, on a monitor,
 * at 300 %, in a resized window.
 *
 * Both helpers are pure and total. Fractions are never clamped: a mark placed
 * past the edge of the page is kept where it was put.
 */
export const toSheet = (mark, box) => {
  const fx = (v) => (v - box.left) / box.width;
  const fy = (v) => (v - box.top) / box.height;
  const out = { ...mark, space: 'sheet', x: fx(mark.x || 0), y: fy(mark.y || 0) };
  if (mark.width !== undefined && mark.width !== null) out.width = mark.width / box.width;
  if (mark.height !== undefined && mark.height !== null) out.height = mark.height / box.height;
  if (Array.isArray(mark.points)) out.points = mark.points.map((p) => ({ x: fx(p.x), y: fy(p.y) }));
  return out;
};

export const toContent = (mark, box) => {
  if (!box || (mark.space || 'px') !== 'sheet') return mark;
  const cx = (v) => box.left + v * box.width;
  const cy = (v) => box.top + v * box.height;
  const out = { ...mark, x: cx(mark.x || 0), y: cy(mark.y || 0) };
  if (mark.width !== undefined && mark.width !== null) out.width = mark.width * box.width;
  if (mark.height !== undefined && mark.height !== null) out.height = mark.height * box.height;
  if (Array.isArray(mark.points)) out.points = mark.points.map((p) => ({ x: cx(p.x), y: cy(p.y) }));
  return out;
};
